import React, { useState } from "react";
import { connect } from "react-redux";

import { Button } from "expano-components";
import { Modal, Select } from "components";
import { url, stringifyQuery } from "utils/api";
import { assignDescriptionSectionProductsImagesByFileName } from "actions/product_group/description_sections";

import useQueryHook from "utils/useQueryHook";

const AssignImagesByFileName = ({
  description_section_id,
  product_id,
  handleClose,
  assignDescriptionSectionProductsImagesByFileName,
}) => {
  const [file_name, setFileName] = useState(null);
  const [is_saving, setSaving] = useState(false);

  const {
    is_loading,
    data: { data },
  } = useQueryHook({
    query_keys: [product_id],
    path: `/product_images?${stringifyQuery({
      context: "ui_product_group_image_files",
      per_page: 100,
      "q[product_id_eq]": product_id,
    })}`,
  });

  const options =
    data?.map(({ image, image_filename }) => ({
      label: (
        <div className="df gap-10 v-center">
          <img
            style={{ width: 30, height: 30, borderRadius: 4 }}
            src={`${url}${image}`}
            alt=""
          />
          <span>{image_filename}</span>
        </div>
      ),
      value: image_filename,
    })) || [];

  const handleSubmit = async () => {
    try {
      setSaving(true);
      await assignDescriptionSectionProductsImagesByFileName({
        id: description_section_id,
        file_name,
      });
      handleClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      size="md"
      handleClose={handleClose}
      header={{
        title: "Przypisz zdjęcia produktom w sekcji",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="save"
            disabled={!file_name || is_saving}
            text={is_saving ? "Proszę czekać..." : "Przypisz"}
            onClick={handleSubmit}
          />
        </>
      }
    >
      <Select
        label="Nazwa piilku"
        isDisabled={is_loading}
        handleChange={(value) => setFileName(value)}
        options={options}
      />
    </Modal>
  );
};

export default connect(null, (dispatch) => ({
  assignDescriptionSectionProductsImagesByFileName: (data) =>
    dispatch(assignDescriptionSectionProductsImagesByFileName(data)),
}))(AssignImagesByFileName);
